module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAWCAIAAABVH8vfAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAEHSURBVDhP1dM9i8IwGMBxP9GNbo439ls4uvkRujne2NFVQlDEI0gl4NAloFIqJSKiHEgpqHCIxcnnqmhejA2Hg8JvydPkXwht6ZAdn+INQj8TjxAHtytn3SBWNoANbwZ8Kw+l0Db0y4h4jMdJur7YiRv+bCIX4TpLlLkQ2vMG6rWT27M7DBUghGL60WXr61JnrgAhFPqlfnRbKh5WgF2oqAIsQhYVUBSyq4CiULIgM73Cv7Tvy/qyJZHb8qk8fOnQKnA6weK6fCDfab6jbOlh7Ibaz6Xa0T7+HC6VuRiCV7EqQg6hjYFRrYPK3yzeC6dycgj8puPphIyM6DxVj+S00H+9Wig7ngA7cbi3z97RpwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/image/80.png
// module id = 433
// module chunks = 1 2 3 4 5 6 7 8